import { any, func } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import history from "../../history";
import { postRoyalMailForm } from "../../redux/actions/royalMailActions";

const SecurityForm = ({ appData, postRoyalMailFormFunc }) => {
  const initialState = {
    answer: {
      title: "Have you had any Road Traffic Collisions in the past 3 years?",
      type: "checkbox",
      mandatory: true,
    },
    details: {
      title: "If yes, how many?",
      dependOn: [
        {
          fieldKey: "answer",
        },
      ],
      value: "",
      mandatory: true,
    },
  };
  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postRoyalMailFormFunc("traffic", {
      ...fieldValuesPayload,
      name: `${appData.firstName} ${appData.lastName}`,
    });
    history.push("/profile/edit/royal-mail-onboarding");
  };

  return (
    <FormCreator
      formTitle={"Traffic"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
    />
  );
};
SecurityForm.propTypes = {
  appData: any,
  postRoyalMailFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postRoyalMailFormFunc: postRoyalMailForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(SecurityForm);
